export default __webpack_public_path__ + "static/media/vBankSmallLogo.0a5263ed.svg";